import { ReactNode } from 'react'
import { FileText } from 'lucide-react'
import { Card } from '@/components/ui/card'

interface DocumentSheetProps {
  title: string
  subtitle: string
  icon?: ReactNode
  badge?: ReactNode
  children: ReactNode
}

// Bounded "sheet" for a generated document. Gives the content a clear top/bottom
// edge and a labeled header so a long document no longer blurs into the next
// section on the process page. The body still renders the shared DocumentPreview.
export default function DocumentSheet({
  title,
  subtitle,
  icon = <FileText className="size-5" />,
  badge,
  children,
}: DocumentSheetProps) {
  return (
    <Card className="gap-0 overflow-hidden py-0">
      <div className="flex items-center gap-3 border-b px-5 py-4">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted text-foreground">
          {icon}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2 text-[15px] font-semibold leading-none">
            {title}
            {badge}
          </div>
          <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>
        </div>
      </div>
      <div className="px-6 py-5">{children}</div>
    </Card>
  )
}
